const DarkStylesheet = () => {
  return (
    <head>
      <link rel="stylesheet" href="/css/dark.css" />
    </head>
  );
};

export default DarkStylesheet;
